export default __webpack_public_path__ + "static/media/medina-circle.492167e3.png";